import { IOrderListSearchState } from "../OrderListSearch";
import { SET_FILTER_COUNT, SET_FILTER_STATE, SET_SEARCH_STATE, SET_SEARCH_TERM } from "./OrderList.action";

export interface IOrderListState {
    filterState: IFilterState;
    filterCount: number;
    searchTerm: string;
    searchState: IOrderListSearchState;
};

export interface IFilterState {
    HOME_DELIVERY: boolean;
    COLLECTION: boolean;
    TABLE_DELIVERY: boolean;
    tableAreas: Record<string, boolean>;
}

export function OrderListReducer(state: IOrderListState, action: any) {
    switch (action.type) {
        case SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload
            }
        case SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.payload
            }
        case SET_FILTER_COUNT:
            return {
                ...state,
                filterCount: action.payload
            }
        case SET_SEARCH_STATE:
            return {
                ...state,
                searchState: action.payload
            }
        default:
            return { ...state };
    }
};